import React, {FC, useEffect} from "react"

import {CompanyNewsTile} from "@irati/types"

import {cultureHubNotificationsCountVariables, useClearNotificationCountMutation} from "@irati/notifications/hooks"
import getNotificationCountQuery from "@irati/notifications/apollo/queries/count"
import authentication from "@irati/auth"
import {HomePageView} from "../types"
import CompanyNewsEditable from "./CompanyNewsEditable"
import CompanyNewsNonEditable from "./CompanyNewsNonEditable"

interface Props {
  companyNews: CompanyNewsTile[]
  id: string
  pageView: HomePageView
  toggleEditView: () => void
}

const CompanyNews: FC<Props> = ({companyNews, id, pageView, toggleEditView}) => {
  const [clearCultureHubNotifications] = useClearNotificationCountMutation({
    variables: cultureHubNotificationsCountVariables,
    refetchQueries: [{query: getNotificationCountQuery, variables: cultureHubNotificationsCountVariables}]
  })

  useEffect(() => {
    if (!authentication.isUserGhost()) {
      clearCultureHubNotifications()
    }
  }, [])

  if (pageView === HomePageView.EMPLOYEE_VIEW) {
    return <CompanyNewsNonEditable id={id} companyNews={companyNews} pageView={pageView} toggleEditView={toggleEditView} />
  }

  return <CompanyNewsEditable id={id} companyNews={companyNews} pageView={pageView} toggleEditView={toggleEditView} />
}

export default CompanyNews
